import { Link, useParams } from 'react-router-dom';
import './MyNotes.css';
import { courseRegistry } from '../../courses/courseRegistry';

export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL

console.log("Fetching notes from:", `${API_URL}/notes`);

export default function CourseGateway() {
  const { courseSlug } = useParams();
  const courseConfig = courseRegistry[courseSlug];

  if (!courseConfig) return <div>Course not found</div>;
  
  const NotesComponent = courseConfig.noteComponent;

  if (!NotesComponent) return <div>No notes for this course</div>;

  return <NotesComponent />;
}

/*old version moved to content/Mynotes  as a local component and this has been changed to be a multipurpose gateway*/